import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FileUpload, ProgressUpload } from "mdi-material-ui";
import locale from "@bonliva-crm/locale";
import { FormSection } from "@components/forms/common";
import { Body, RegularButton, WithTooltip } from "@components";
import DnDLocalContainer from "@containers/DnDContainer/DnDLocalContainer";
import { DocumentList } from "@containers/DocumentList";
import { ThemeType } from "@theme";
import { SubcontractorDocument } from "./SubcontractorDocument";

type Props = {
  disabled: boolean;
  canViewDocuments: boolean;
  canDeleteDocuments: boolean;
  canUpload: boolean;
  onStartUpload: (files?: File[]) => void;
  onRemove: (docId: string) => void;
  docs: SubcontractorDocument[];
};

export function SubcontractorDocs(props: Props) {
  const classes = useStyles({});

  return (
    <FormSection flat withBorder fullWidth PaperProps={{ style: { padding: 0 } }}>
      <DnDLocalContainer
        className={classes.withFileUpload}
        overlayProps={{ className: classes.dndOverlay }}
        onDrop={props.onStartUpload}
        noClick
        disabled={props.disabled}
      >
        <Body>Underleverantörsfaktura</Body>

        <DocumentList
          hideEmptyTitle={true}
          className={classes.documentList}
          documents={props.docs}
          disabledOnDelete={() => !props.canDeleteDocuments}
          disabledOnDocument={() => !props.canViewDocuments}
          onDelete={(doc) => props.onRemove(doc.FileRef.NodeID)}
          getRowProps={(doc: SubcontractorDocument) => {
            const extraContent = doc.isNew ? (
              <WithTooltip title="Save to persist">
                <ProgressUpload fontSize="small" color="primary" />
              </WithTooltip>
            ) : null;

            const textDecoration = doc.isDeleted ? "line-through" : "initial";

            return {
              extraContentAfterName: extraContent,
              style: { textDecoration }
            };
          }}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        />

        <div className={classes.uploadBtnWrapper}>
          <RegularButton
            variant="text"
            disabled={props.disabled || !props.canUpload}
            leftIcon={<FileUpload />}
            onClick={() => props.onStartUpload()}
          >
            {locale.UploadForSubContractor}
          </RegularButton>
        </div>
      </DnDLocalContainer>
    </FormSection>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  dndOverlay: { borderRadius: 4 },
  documentList: { flex: "1 0 100%" },

  uploadBtnWrapper: {
    padding: "4px 0",
    flex: "1 0 100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  withFileUpload: {
    position: "relative",
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 16
  }
}));
